import React from 'react';
import { Drawer } from '@material-ui/core';

import styles from './index.module.scss';

/** Advance menu to show forms */
const AdvanceMenu = (props: any) => {
    const { open, onClose, children } = props;
    return (
        <Drawer anchor="right" open={open} onClose={onClose} className={styles.container}>
            {children}
        </Drawer>
    );
}

export default AdvanceMenu;